import { FC } from 'react';

import {
  WbBadge,
  WbBadgeProps,
  WitboostPaletteColor,
} from '@agilelab/plugin-wb-platform';
import { PrototypeStatus } from '@agilelab/plugin-wb-system-prototype-common';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import LightbulbIcon from '@material-ui/icons/EmojiObjects';
import SearchIcon from '@material-ui/icons/Search';

export const STATUS_OPTIONS_MAP: Record<
  PrototypeStatus,
  { label: string; color: WitboostPaletteColor; icon: JSX.Element }
> = {
  [PrototypeStatus.IDEA]: {
    label: 'Idea',
    color: 'accent',
    icon: <LightbulbIcon fontSize="small" />,
  },
  [PrototypeStatus.DISCOVERY]: {
    label: 'Discovery',
    color: 'warning',
    icon: <SearchIcon fontSize="small" />,
  },
  [PrototypeStatus.VALIDATED]: {
    label: 'Validated',
    color: 'primary',
    icon: <DoneAllIcon fontSize="small" />,
  },
  [PrototypeStatus.APPROVED]: {
    label: 'Approved',
    color: 'success',
    icon: <CheckIcon fontSize="small" />,
  },
  [PrototypeStatus.REJECTED]: {
    label: 'Rejected',
    color: 'secondary',
    icon: <CloseIcon fontSize="small" />,
  },
};

type PrototypeStatusBadgeProps = {
  status: PrototypeStatus;
} & WbBadgeProps;

export const PrototypeStatusBadge: FC<PrototypeStatusBadgeProps> = ({
  status,
  ...props
}) => {
  const statusOption = STATUS_OPTIONS_MAP[status];
  return (
    <WbBadge
      {...props}
      color={statusOption.color}
      startIcon={statusOption.icon}
    >
      {statusOption.label}
    </WbBadge>
  );
};
